import { ChatContainer } from '@/components/SearchAssistant/components/ChatContainer';
import { ChatContent } from '@/components/SearchAssistant/components/ChatContent';
import { ChatSidebar } from '@/components/SearchAssistant/components/ChatSidebar';
import { ErrorBoundary } from '@/components/SearchAssistant/components/ErrorBoundary';
import { useFeatureFlags } from '@/contexts/FeatureFlagsContext';
import { searchAssistantUIStore } from '@/stores/searchAssistantStore';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

export const SearchAssistant = () => {
  const { searchAssistant = false } = useFeatureFlags();

  useEffect(() => {
    searchAssistantUIStore.getState().setRenderTriggerButton(searchAssistant);
  }, [searchAssistant]);

  if (!searchAssistant) {
    return null;
  }

  const chatWindowContent = (
    <ChatContainer>
      <ErrorBoundary>
        <ChatSidebar />
        <ChatContent />
      </ErrorBoundary>
    </ChatContainer>
  );

  return createPortal(chatWindowContent, document.body);
};
